import Countdown from 'react-countdown';
import { Button, Image } from 'antd';
import classNames from 'classnames';

import { ButtonCategoryProps, ButtonCountdownCProps, ButtonCProps } from 'src/interface/Layout/Button';
import { timeToTextFormatted } from 'src/utils/func/format-time';

import classes from './index.module.less';

const ButtonC = (props: ButtonCProps) => {
	return (
		<Button {...props} className={`${classes.button} ${props.className}`}>
			{props.text}
		</Button>
	);
};

export const ButtonOK = (props: ButtonCProps) => {
	return <ButtonC {...props} type="primary" text={props.text} />;
};

export const ButtonCountdown = (props: ButtonCountdownCProps) => {
	const renderer = ({ formatted, completed }: any) => {
		if (completed) {
			return (
				<Button {...props} className={`${classes.button} ${props.className}`}>
					{props.label}
				</Button>
			);
		}

		return (
			<Button {...props} className={`${classes.button} ${props.className}`}>
				<span>{props.text}</span>
				<span className="ml-2">
					{timeToTextFormatted(formatted.hours, formatted.minutes, formatted.seconds, false)}
				</span>
			</Button>
		);
	};

	return props.countdown > 0 ? (
		<Countdown date={Date.now() + props.countdown} renderer={renderer} />
	) : (
		<Button {...props} className={`${classes.button} ${props.className}`}>
			{props.text}
		</Button>
	);
};

export const ButtonBorder = ({ className, text, ...props }: ButtonCProps) => {
	return (
		<Button className={classNames(`${classes['button-border']}`, className)} {...props}>
			{text}
		</Button>
	);
};

export const ButtonBorderGroup = ({ className, text, ...props }: ButtonCProps) => {
	return (
		<Button className={classNames(`${classes['button-border-group']}`, className)} {...props}>
			<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
				<span style={{ marginLeft: '15px', marginTop: '2px' }}>{text}</span>
				{<span style={{marginTop: '2px', marginRight: '-5px'}}>
					<Image
						alt="Chevron Right"
						src="/icons/arrow-chevron-down.svg"
						width={12}
						height={12}
						preview={false}
					/></span>}
			</div>
		</Button>
	);
};

export const ButtonBorderTabPhase = ({ className, text, ...props }: ButtonCProps) => {
	return (
		<Button className={classNames(`${classes['button-border-phase']}`, className)} {...props}>
			{text}
		</Button>
	);
};

export const ButtonBorderTabCategory = ({ className, text, image, ...props }: ButtonCategoryProps) => {
	return (
		<Button
			className={classNames(`${classes['button-border-category']}`, className)}
			{...props}>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'flex-start',
					gap: '4px',
					padding: '0px 12px',
				}}>
				<Image
					loading='lazy'
					src={image}
					width={16}
					height={16}
					alt="Icon"
					preview={false}
					style={{
						flexShrink: 0,
						marginRight: '5px',
					}} />
				<span style={{ flex: 1, marginTop:'2px' }}>{text}</span>

			</div>
		</Button>
	);
};

export const ButtonText = (props: ButtonCProps) => {
	return (
		<Button
			{...props}
			className={classNames(classes['button-border'], classes['button-text'], props.className)}
		>
			{props.text}
		</Button>
	);
};
export const ButtonBorderKomunitas = ({ className, text, ...props }: ButtonCProps) => {
	return (
		<Button className={classNames(`${classes['button-border-komunitas']}`, className)} {...props}>
			{text}
		</Button>
	);
};
export const ButtonBorderKomunitasBeranda = ({ className, text, ...props }: ButtonCProps) => {
	return (
		<Button
			className={classNames(`${classes['button-border-komunitas-beranda']}`, className)}
			{...props}
		>
			{text}
		</Button>
	);
};
export const ButtonBorderKomunitasDetailArtikel = ({ className, text, ...props }: ButtonCProps) => {
	return (
		<Button
			className={classNames(`${classes['button-border-komunitas-detail-artikel']}`, className)}
			{...props}
		>
			{text}
		</Button>
	);
};

export default ButtonC;
